import { Workspace } from "./types";

export const workspaces: Workspace[] = [
  {
    id: "finance",
    logo: `/assets/icons/workspaces/finance.png`,
    name: "Finance",
  },
];
